/**
 * Application Routes Configuration
 */

// Route paths as constants for type-safe navigation
export const Routes = {
  LANDING: "/",
  HOME: "/home",
  CALL: "/call",
} as const;
